import React from 'react';
import ButtonPrimary from '../../Form/ButtonPrimary';
import { formatCurrency } from '../../../Utils/Formatters';
import { useCartContext } from '../../../Contexts/CartContext';
import { ImSpinner8 } from 'react-icons/im';
import { useTranslation } from 'react-i18next';

interface ButtonAddProductProps {
    currentProduct: any;
    currentPrice: any;
    onHandleAdd: CallableFunction;
    disabledButtonAddProduct: boolean;
}

const ButtonAddProduct = ({
    currentProduct,
    currentPrice,
    onHandleAdd,
    disabledButtonAddProduct = true
}: ButtonAddProductProps) => {

    const { t } = useTranslation();
    const { loadingCurrentCart, loadingUpdateQuantity } = useCartContext();

    return (
        <ButtonPrimary
            onClick={onHandleAdd}
            disabled={disabledButtonAddProduct}
            className="
                flex w-full md:w-auto md:min-w-64 gap-1 md:gap-6 leading-5
                justify-between
            ">
                {(loadingCurrentCart || loadingUpdateQuantity)
                    ? <div className="flex items-center justify-center gap-1 text-white w-full"><span><ImSpinner8 className="animate-spin" /></span><span>{t('add_product.button_add.loading')}</span></div>
                    :
                    <>
                        <span className={`${formatCurrency(currentProduct?.quantity * currentPrice, false).length > 8 && 'text-sm'}`}>{t('add_product.button_add.label')}</span>
                        <span>{ formatCurrency(currentProduct?.quantity * currentPrice, false) }</span>
                    </>
                }
          </ButtonPrimary>
    );
};

export default ButtonAddProduct;
